module.exports = __webpack_public_path__ + "videos/mts-products-chats-favorite-features.33327ec.webm";